module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-16.99f6f7fd.svg";